import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { useLanguage } from "../../contexts/LanguageContext";
import SocialMediaSlider from "./SocialMediaSlider.jsx";

export default function DataSection(props) {
  const [selected, setSelected] = useState();
  const [activeId, setActiveId] = useState(null);
  const { language } = useLanguage();
  const [currentImage, setCurrentImage] = useState("");
  const [activeButton, setActiveButton] = useState("monthly");

  const handleImageChange = (type) => {
    setActiveButton(type);
    if (type === "daily") {
      setCurrentImage(
        "https://srv-cdn.onedio.com/store/0580fe0a9e71f377c477bd1c1fe91a3c430b2f5f3263944a97444dfaf6052351.png"
      );
    } else if (type === "monthly") {
      setCurrentImage(
        "https://srv-cdn.onedio.com/store/46e9949bee4244c99e18ce22162639ad7f7668351715205c83239abf21364d47.png"
      );
    }
  };

  const handleSelected = (id) => {
    const newItem = props.data.find((item) => item.id === id);
    if (newItem) {
      setSelected(newItem);
      setActiveId(id);
      gsap.fromTo(".data-img", { opacity: 0 }, { opacity: 1, duration: 1 });
    }
  };

  useEffect(() => {
    const activeItem = props.data.find((item) => item.active);
    if (activeItem) {
      setSelected(activeItem);
      setActiveId(activeItem.id);
    }
  }, [props.data]);

  useEffect(() => {
    if (selected && selected.id === 5) {
      setCurrentImage(
        "https://srv-cdn.onedio.com/store/0580fe0a9e71f377c477bd1c1fe91a3c430b2f5f3263944a97444dfaf6052351.png"
      );
    } else if (selected && !selected.socialSlides) {
      setCurrentImage(
        language === "EN" && selected.imageEN
          ? selected.imageEN
          : selected.image
      );
    }
  }, [selected, language]);

  useEffect(() => {
    handleImageChange(activeButton);
  }, []);

  return (
    <div
      className="flex flex-col gap-5 px-1 lg:px-10 lg:py-16 py-6 max-w-[1440px] mx-auto mt-5"
      id={props.name}
    >
      <div className="text-3xl lg:text-5xl font-semibold text-black">
        {language === "EN" ? props.titleEN : props.title}
      </div>
      <div className="flex items-center flex-col lg:flex-row gap-5 h-auto">
        <ul className="flex lg:flex-col gap-3 nav-v-pill-wrapper absolute lg:relative w-full lg:w-auto overflow-x-auto">
          {props.data.map((data) => (
            <li
              className={`h-10 lg:h-16 lg:w-[460px] border whitespace-nowrap w-full flex items-center px-4 lg:pl-4 text-md cursor-pointer transition-all duration-200 ${
                data.id === activeId
                  ? "active font-semibold border-[#FD9790] bg-[#FEF9F3] shadow-sm"
                  : "hover:bg-gray-50"
              }`}
              key={data.id}
              onClick={() => handleSelected(data.id)}
            >
              {language === "EN" ? data.titleEN : data.title}
            </li>
          ))}
        </ul>
        <div className="mt-24 lg:mt-0">
          {selected && selected.id === 5 && (
            <div>
              <div className="max-w-[760px] text-[#697883] text-base w-full xl:w-[950px]">
                {language === "EN"
                  ? selected.descriptionEN
                  : selected.description}
              </div>
              <button
                onClick={() => handleImageChange("monthly")}
                className={`rounded-lg border border-gray-200 bg-white py-3 px-3 mt-4 mb-4 ${
                  activeButton === "monthly" ? "shadow-lg" : ""
                }`}
              >
                Aylık
              </button>
              <button
                onClick={() => handleImageChange("daily")}
                className={`rounded-lg border border-gray-200 bg-white py-3 px-3 mt-4 mb-4 mx-2 ${
                  activeButton === "daily" ? "shadow-lg" : ""
                }`}
              >
                Günlük
              </button>
            </div>
          )}
          {selected && selected.socialSlides && props.socialSlides ? (
            <SocialMediaSlider slides={props.socialSlides} />
          ) : (
            selected && (
              <img
                src={currentImage}
                className="max-w-[760px] w-full data-img"
                alt="Selected Image"
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}
